function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.333 19h-2a2 2 0 01-2-2V7h2v10h4v1.764L11.861 17h2.472v2h-2l-6 3v-3z",
  fill: "#A7AEB7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.333 15h2a2 2 0 002-2V4a2 2 0 00-2-2h-12a2 2 0 00-2 2v9a2 2 0 002 2h4l6 3v-3zm-5.528-2H8.333V4h12v9h-4v1.764L12.805 13z",
  fill: "#F2F5F9"
});

var SvgInteractWithOthers = function SvgInteractWithOthers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMzMzMzEgMTlINC4zMzMzMUMzLjIyODc0IDE5IDIuMzMzMzEgMTguMTA0NiAyLjMzMzMxIDE3VjdINC4zMzMzMVYxN0g4LjMzMzMxVjE4Ljc2MzlMMTEuODYxMiAxN0gxNC4zMzMzVjE5SDEyLjMzMzNMNi4zMzMzMSAyMlYxOVoiIGZpbGw9IiNBN0FFQjciLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC4zMzMzIDE1SDIwLjMzMzNDMjEuNDM3OSAxNSAyMi4zMzMzIDE0LjEwNDYgMjIuMzMzMyAxM1Y0QzIyLjMzMzMgMi44OTU0MyAyMS40Mzc5IDIgMjAuMzMzMyAySDguMzMzMzFDNy4yMjg3NCAyIDYuMzMzMzEgMi44OTU0MyA2LjMzMzMxIDRWMTNDNi4zMzMzMSAxNC4xMDQ2IDcuMjI4NzQgMTUgOC4zMzMzMSAxNUgxMi4zMzMzTDE4LjMzMzMgMThWMTVaTTEyLjgwNTQgMTNIOC4zMzMzMVY0SDIwLjMzMzNWMTNIMTYuMzMzM1YxNC43NjM5TDEyLjgwNTQgMTNaIiBmaWxsPSIjRjJGNUY5Ii8+Cjwvc3ZnPgo=";
export { SvgInteractWithOthers as ReactComponent };